import React from "react";
import twitterImg from "../../assets/social-media-icons/twitter.png";
import discordImg from "../../assets/social-media-icons/discord.svg";
import classes from "../partials/Footer.module.css";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <div className={classes["footer-wrapper"]}>
      <div className={classes["navbar-paginatiion-links"]}>
        <Link to="/#">
          <div className={classes["links-icon"]}>
            <a
              href="https://www.magiceden.io/marketplace/spacekitties"
              target="_blank"
              rel="noreferrer"
            >
              Space Kitties on MagicEden
            </a>
          </div>
        </Link>
        <Link to="/game">
          <div className={classes["links-icon"]} style={{ marginLeft: "1rem" }}>
            Battle Mech Game
          </div>
        </Link>
      </div>
      <div className={classes["footer-content-wrapper"]}>
        <a
          href="https://discord.gg/fpkXATuucr"
          target="_blank"
          rel="noreferrer"
        >
          <img className={classes["icon"]} src={discordImg} alt="" />
        </a>
        <a
          href="https://twitter.com/spacekittiesxyz"
          target="_blank"
          rel="noreferrer"
        >
          <img className={classes["icon"]} src={twitterImg} alt="icon" />
        </a>
      </div>
    </div>
  );
};

export default Footer;
